import { render, staticRenderFns } from "./BillDetailsDialog.vue?vue&type=template&id=58fe420a&scoped=true"
import script from "./BillDetailsDialog.vue?vue&type=script&lang=js"
export * from "./BillDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./BillDetailsDialog.vue?vue&type=style&index=0&id=58fe420a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe420a",
  null
  
)

export default component.exports